<ng-container *ngIf="appointment">
  <ng-container *ngIf="!workflow; else workflowTemplate">
    <button
      *appHasPermission="['invoice.create', 'invoice.view']"
      mat-icon-button
      class="status-icon"
      [matMenuTriggerFor]="paymentMenu"
      [matTooltip]="appointment.paymentStatusText | translate"
      matTooltipPosition="above"
      (click)="$event.stopPropagation()"
      (menuOpened)="menuOpened()"
    >
      <mat-progress-spinner
        *ngIf="inProgress"
        diameter="30"
        mode="indeterminate"
      ></mat-progress-spinner>
      <mat-icon *ngIf="!inProgress" [ngClass]="paymentStatusColor(appointment.paymentStatus)">
        <ng-container *ngIf="appointment.paymentStatus === PAYMENT_STATUS.FULL; else paymentIcon">
          credit_score
        </ng-container>
        <ng-template #paymentIcon>payment</ng-template>
      </mat-icon>
    </button>

    <mat-menu #paymentMenu="matMenu">
      <ng-container *ngIf="appointment.invoices == null; else invoiceMenuItems">
        <button mat-menu-item>Loading…</button>
      </ng-container>
      <ng-template #invoiceMenuItems>
        <ng-container *ngIf="appointment.validInvoices.length === 0">
          <a
            *appHasPermission="'invoice.create'"
            mat-menu-item
            [routerLink]="appointment.url"
          >
            Create invoice from estimate
          </a>
        </ng-container>
        <ng-container *ngIf="appointment.validInvoices.length > 0">
          <ng-container *appHasPermission="'invoice.view'">
            <a
              mat-menu-item
              *ngFor="let invoice of appointment.validInvoices"
              [routerLink]="invoice.url"
            >
              View Invoice {{ invoice.shortId | shortId }}
              {{ invoice.total | currency: invoice.currency }}
            </a>
            <a
              mat-menu-item
              *ngFor="let invoice of appointment.validInvoices"
              [routerLink]="invoice.url"
            >
              Collect Payment for Invoice {{ invoice.shortId | shortId }}
            </a>
          </ng-container>
        </ng-container>
      </ng-template>
      <!-- <button mat-menu-item>
        Add payment method
      </button> -->
    </mat-menu>
  </ng-container>
  <ng-template #workflowTemplate>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon
        [ngClass]="paymentStatusColor(appointment.paymentStatus)"
        fxFlex="25px"
      >
        <ng-container *ngIf="appointment.paymentStatus === PAYMENT_STATUS.FULL; else paymentIcon">
          credit_score
        </ng-container>
        <ng-template #paymentIcon>payment</ng-template>
      </mat-icon>
      <span>{{ appointment.paymentStatusText | translate }}</span>
    </div>
  </ng-template>
</ng-container>

<button *ngIf="status" mat-stroked-button>
  <mat-icon [ngClass]="paymentStatusColor(this.status)">
    <ng-container
      *ngIf="status === PAYMENT_STATUS.FULL else assignmentTurnedIcon1">
      credit_score
    </ng-container>
    <ng-template #assignmentTurnedIcon1>payment</ng-template>
  </mat-icon>
  {{ paymentDisplayStatus(this.status) | translate }}
</button>
